import {
  createPortableDialog,
  usePortableDialog,
  Dialog,
  DialogCloseButton,
  DialogContent,
} from '@wwe-portal/ui/components/dialog';
import React from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';
import AvatarSelect from '../avatar-select/avatar-select';

const AvatarSelectDialog = () => {
  const modal = usePortableDialog();
  const onClose = () => {
    modal.remove();
  };
  return (
    <Dialog
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
      open={modal.visible}
    >
      <DialogContent
        className={cn(
          'w-[280px] md:h-[440px] md:w-[720px] md:max-w-[720px] 2xl:h-[520px] 2xl:w-[1000px] 2xl:max-w-[1000px]'
        )}
        data-id="login-dialog"
        variant="message"
      >
        <AvatarSelect onClose={onClose} />
        <DialogCloseButton onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};

export const AvatarSelectDialogPortal =
  createPortableDialog(AvatarSelectDialog);
